import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import axios from 'axios';
import VueSwal from 'vue-swal'
import VeeValidate from 'vee-validate';
import BlockUI from 'vue-blockui'

 

import Signup from './components/Signup.vue'
import Login from './components/Login.vue'
import Mainform from './components/Mainform.vue'
import Summary from './components/Summary.vue';

import AdminLogin from './components/AdminLogin.vue'
import Dashboard from './components/Dashboard.vue';
// import moment from 'moment';
// import VueMoment from 'vue-moment';
// Vue.use(require('vue-moment'));
// Vue.use(VueMoment, { moment });

Vue.use(VeeValidate)
Vue.use(VueSwal)
Vue.use(VueRouter)
Vue.use(BlockUI)
Vue.prototype.$http = axios;
Vue.config.productionTip = false

Vue.mixin({
  data() {
    return {
      appenv:{
        token:'ABC',
        key:'123',
           baseurl:'https://sts.ug.edu.gh/itsev8engine/api/phdfellow',
		  //baseurl:'http://localhost/itsev8engine/api/phdfellow',
		  files:'https://sts.ug.edu.gh/itsev8engine/public/phd'
      }
    }
  }
});
const router = new VueRouter({
  routes:[
    {path:'/',component:Login},
    {path:'/login',component:Login},
    {path:'/apply',component:Mainform},
    {path:'/summary',component:Summary},
	{path:'/signup',component:Signup},
	{path:'/master/login',component:AdminLogin},
	{path:'/master/dashboard',component:Dashboard}
  ]
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
